module.exports = __webpack_public_path__ + "static/media/landpage-matilde.7a178674.png";